import React, {Component, Fragment} from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import AssessmentPage from './AssessmentPage';
import moment from 'moment';
import GroupDetailsTable from './GroupDetailsTable';
import {Button, Panel} from 'react-bootstrap';
import ProgressBarItem from './ProgressBar';
import ErrorComponent from '../ErrorComponent';

class GroupReportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: {},
      team: {},
      groupAssessment: {},
      inviteDetails: [],
      isLoading: true,
      coach: '',
      subScores: [],
      errors: []
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const team = await GreenLeafApi.Team.get({ teamId: this.props.match.params.teamId });
      const groupAssessment = await GreenLeafApi.GroupTeamAssessment.getScore({ group_team_assessment_id: this.props.match.params.groupAssessmentId });
      const answers = await GreenLeafApi.GroupTeamAssessment.getAnswerAverages(this.props.match.params.groupAssessmentId);
      const details = (await GreenLeafApi.GroupTeamAssessment.get({group_assessment_id: this.props.match.params.groupAssessmentId}));
      const subsectionScores = (await GreenLeafApi.GroupTeamAssessment.getSubScores({group_team_assessment_id: this.props.match.params.groupAssessmentId})).data.scores;

      const coach = groupAssessment.data.score[0].user_name || 'N/A';

      let questions = {};
      if (answers.data.answers) {
        questions = answers.data.answers.reduce((res, a) => {
          res[a.id] = { answer: a.score, comment: a.comments };
          return res;
        }, {});
      }

      this.setState({ questions, team: team.data[0], groupAssessment: groupAssessment.data.score[0], inviteDetails: details.data, subScores: subsectionScores, coach});
    } catch (e) {
      this.setState({ errors: [{ msg: 'Error loading scores. Please try again later.' }] });
    }

    this.setState({ isLoading: false });
  };

  closeAssessment = async () => {
    try {
      await GreenLeafApi.GroupTeamAssessment.closeAssessment(this.props.match.params.groupAssessmentId);
      await this.fetchData();
      this.props.history.push(`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}`);
    } catch (e) {
      this.setState({ errors: e.errors  });
    }
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading...</p>;
    }

    return (
      <div>
        <ErrorComponent error={this.state.errors}/>
        <h2 data-cy="report-header" align="center">
          Self Assessment Report: {this.state.team.name}
        </h2>
        <br/>
        <div data-cy='group-progress-bar'  align='center'>
            { this.state.groupAssessment.calculated_score ?
                <ProgressBarItem
                    placement={'right'}
                    score={this.state.groupAssessment.calculated_score}
                    width={'500px'}/> : null }
        </div>
        <div className='flex-row-spaced'>
          <div data-cy='group-assess-date' className="pl1">Date Started: {moment(new Date(this.state.groupAssessment.assessment_date)).format('MM/DD/YYYY')}</div>
          <div className='pr1' align='right'>
            <div data-cy='status'>Status: {this.state.groupAssessment.complete ? 'Closed' : <Fragment>Open <Button bsSize="xsmall" className={'ml1'} onClick={this.closeAssessment}>Close</Button></Fragment>}</div>
            <div data-cy='opened-by' className='mt1'>Opened by: {this.state.coach}</div>
          </div>
        </div>

        <AssessmentPage
          groupAssessmentId={this.props.match.params.groupAssessmentId}
          averageScores
          disabled
          answers={this.state.questions}
          subScores={this.state.subScores.length > 0 ? this.state.subScores : null}
        />

        <Panel>
          <Panel.Heading>
            <Panel.Title>Details</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <GroupDetailsTable
              closed={this.state.groupAssessment.complete}
              details={this.state.inviteDetails}
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default GroupReportPage;



// WEBPACK FOOTER //
// ./src/components/teams/GroupReportPage.js